import { jsx } from "react/jsx-runtime";
import { IconButton } from "../IconButton/index.js";
const CarouselLightboxButton = ({ onClick, iconButtonProps = {}, lightboxButtonClasses = '', ...props })=>{
    const { iconName = 'photo_library', size = '3xs', ...restProps } = iconButtonProps;
    const handleClick = (event)=>{
        event.stopPropagation();
        onClick();
    };
    return /*#__PURE__*/ jsx("div", {
        className: lightboxButtonClasses,
        ...props,
        children: /*#__PURE__*/ jsx(IconButton, {
            "data-testid": "carousel-lightbox-button",
            type: "plainPrimary",
            emphasis: "bold",
            size: size,
            iconName: iconName,
            onClick: handleClick,
            ...restProps
        })
    });
};
export { CarouselLightboxButton };
